import type { CardProps } from '@mantine/core';
import { Card } from '@mantine/core';
import type { ReactNode } from 'react';

import { UnstyledNextLink } from '~/components/shared/UnstyledNextLink/UnstyledNextLink';

type ContestCardFrameProps = CardProps & {
  // The card's navigation target. When set, the card is a link (full-page nav via UnstyledNextLink);
  // when null, a plain div — each use case injects its own destination (contest game centre,
  // marketplace route) rather than the shell deriving it.
  href: string | null;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement | HTMLDivElement>) => void;
  children: ReactNode;
};

// The presentational card shell shared by the contest card and the marketplace card: the Mantine
// Card with the caller's padding/shadow/radius, rendered as a link or a div depending on href.
export function ContestCardFrame({ href, onClick, children, ...cardProps }: ContestCardFrameProps) {
  const disableLink = !href;

  return (
    <Card
      {...cardProps}
      component={disableLink ? 'div' : UnstyledNextLink}
      href={href}
      onClick={onClick}
    >
      {children}
    </Card>
  );
}
